import React from "react"
import ChantalImg from "../../../images/chantal.svg"

const UniqueExperience = () => {
  return (
    <section className="bg-tertiary text-white h-128 md:h-56 lg:h-80">
      <div className="flex flex-col md:flex-row items-center container mx-auto px-6 relative">
        <div className="w-full md:w-1/2">
          <img
            src={ChantalImg}
            alt="A unique experience!"
            className="-top-14 absolute mx-auto w-80 md:w-96 lg:w-128"
          />
        </div>
        <div className="w-full md:w-1/2 pt-60 md:pt-4 lg:pt-20">
          <h4 className="pb-4 text-tertiary text-3xl">A unique experience!</h4>
          <p className="pb-4 text-xl md:text-base lg:text-xl">
            As regards my personal experience, I think that it was a great
            opportunity to strengthen my relationship with my peers.
          </p>
          <p className="text-tertiary">Chantal Boado, Avalither Developer</p>
        </div>
      </div>
    </section>
  )
}

export default UniqueExperience
